import styled from "@emotion/styled";
import { systemWidthSize } from "@kaltura/mediaspace-shared-styled";

export const StyledContentContainer = styled("div")(({ theme }) => ({
    width: "100%",
    maxWidth: systemWidthSize.xl,
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(7.5),
    [theme.breakpoints.down(theme.breakpoints.values.xl)]: {
        maxWidth: systemWidthSize.lg,
    },
    [theme.breakpoints.down(theme.breakpoints.values.lg)]: {
        maxWidth: systemWidthSize.md,
    },
    [theme.breakpoints.down(theme.breakpoints.values.md)]: {
        padding: theme.spacing(0, 3),
    },
    [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
        padding: theme.spacing(0, 2),
    },
}));

export const TitlePlaylistContainer = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing(2),
}));
